import find from './find';
import updateProfil from './updateProfil';
import signUpTunnel from './signUpTunnel';
import create from './create';
import createSubCompany from './createSubCompany';
import companyInfo from './companyInfo';
import updateCompanyInfo from './updateCompanyInfo';
import updatePaymentMethod from './updatePaymentMethod';

export default {
  find,
  create,
  createSubCompany,
  updateProfil,
  signUpTunnel,
  companyInfo,
  updateCompanyInfo,
  updatePaymentMethod,
};
